import React, { Component } from 'react';
import request from 'superagent';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {Button} from 'react-bootstrap';
import TenantAddModal from './TenantAddModal.js';
import ConfirmDialog from '../../commons/ConfirmDialog.js';
import ToolBar from '../../commons/ToolBar.js';
import Loading from '../../commons/Loading.js';
import moment from 'moment';
import TenantDetailView from './TenantDetailView.js';
import NotificationManager from '../../commons/CustomNotificationManager.js';
import {Permissions} from '../../commons/Constants';
import {permissionCheck} from "../../commons/CommonUtils";
import SvgIcon from '../../commons/SvgIcon';
import { Alert } from 'antd';

class TenantView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            selected: [],
            loading: true,
            tenantId: '',
            showAdd: false,
            containerHeight: 700,
            upgradeInfo: {}
        };
    }

    langOptions = [
        {label: "American English", value: 'American English: en-US'},
        {label: "British English", value: 'British English: en-GB'},
        {label: "简体中文", value: 'Simplified Chinese: zh-CN'},
        {label: "繁體中文", value: 'Traditional Chinese: zh-TW'},
        {label: "Français", value: 'French: fr'},
        {label: "Deutsch", value: 'German: de'},
        {label: "日本語", value: 'Japanese: ja'},
        {label: "한국어", value: 'Korean: ko'},
        {label: "Español", value: 'Spanish: es'},
        {label: "Русский", value: 'Russian: ru'},
        {label: "Português", value: 'Portuguese: pt'},
        {label: "العربية", value: 'Arabic: ar'},
        {label: "Magyar", value: 'Hungarian: hu'},
        {label: "Italiano", value: 'Italian: it'},
        {label: "Polski", value: 'Polish: pl'},
        {label: "Norsk", value: 'Norwegian: no'}
    ];

    componentDidMount() {
        this.getTenantList();
    }

    componentWillUnmount() {
        if (this.timer !== null) {
            console.log("destroy interval");
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    getTenantList = () => {
        this.setState({loading: true, dataList: [], selected: [], tenantId: ''});
        this.refs.table.cleanSelected();
        return request.get('/api/tenant-manager')
            .set('Content-Type', 'application/json; charset=utf-8')
            .then(response => {
                this.setState({
                    loading: false,
                    showAdd: false,
                    dataList: response.body.tenants
                });
            })
            .then(() => {
                this.getUpgradeStatus();
            })
            .then(() => {
                const height = document.getElementById('container').clientHeight - 110;
                this.setState({containerHeight: height});
            })
            .catch(err => {
                console.error('Failed to fetch tenants', err);
                NotificationManager.error('Failed to fetch tenants');
                this.setState({
                    dataList: [],
                    selected: [],
                    loading: false,
                    showAdd: false,
                    tenantId: ''
                });
            });
    }

    timer = null;
    getUpgradeStatus = () => {
        return request.get('/api/tenant-manager/upgrade').withCredentials()
            .then(response => {
                this.setState({upgradeInfo: response.body});
                if (response.body.upgradeInProgress) {
                    if (this.timer === null) {
                        console.log("Start interval check");
                        this.timer = setInterval(this.getUpgradeStatus, 10000);
                    }
                } else {
                    if (this.timer !== null) {
                        console.log("Stop interval check");
                        clearInterval(this.timer);
                        this.timer = null;
                        this.getTenantList();
                    }
                }
            })
            .catch(err => {
                console.error('Failed to fetch tenants', err);
                NotificationManager.error('Failed to fetch tenants');
                this.setState({
                    dataList: [],
                    selected: [],
                    loading: false,
                    showAdd: false,
                    tenantId: '',
                    upgradeInfo: {}
                });
            })
    }

    nameCellFormat = (cell, row) => {
        return <a onClick={() => this.setState({tenantId: row.tenantId})}><div>{cell}</div></a>
    }

    versionFormat = (cell) => {
        if (cell) {
            return cell.mongoGen + " - " + cell.configGen;
        } else {
            return '';
        }
    }

    timeFormat = (cell) => {
        if (cell) {
            return moment(cell).local().format("YYYY-MM-DD HH:mm:ss");
        } else {
            return '';
        }
    }

    toggleAddModal = () => {
        this.setState({showAdd: !this.state.showAdd});
    }

    openDeleteModal = () => {
        this.deleteModal.open();
    }

    openUpgradeModal = () => {
        this.upgradeModal.open();
    }

    openUpgradeAllModal = () => {
        this.upgradeAllModal.open();
    }

    openUpgradeGlobalModal = () => {
        this.upgradeGlobalModal.open();
    }

    deleteTenant = () => {
        const selected = this.state.selected;
        let count = 0;
        let failedCount = 0;
        for (let i = 0; i < selected.length; i++) {
            let tenantId = selected[i].tenantId;
            request.delete('/api/tenant-manager/' + tenantId).withCredentials()
                .set('Accept', 'application/json')
                .end((error, response) => {
                    count++;
                    if (error) {
                        console.error(error);
                        failedCount++;
                    }
                    if (count === selected.length) {
                        if (failedCount !== 0) {
                            NotificationManager.error(failedCount + ' of the tenants are failed to be deleted.');
                        } else {
                            NotificationManager.success('Succeed to delete all selected tenants');
                        }
                        this.deleteModal.close();
                        this.getTenantList();
                    }
                });
        }
    }

    upgradeTenant = () => {
        const selected = this.state.selected;
        let count = 0;
        let failed = [];
        for (let i = 0; i < selected.length; i++) {
            let tenantId = selected[i].tenantId;
            request.post('/api/tenant-manager/' + tenantId + "/upgrade").withCredentials()
                .set('Accept', 'application/json')
                .end((error, response) => {
                    count++;
                    if (error) {
                        console.error(error);
                        failed.push(selected[i].companyName);
                    }
                    if (count === selected.length) {
                        if (failed.length !== 0) {
                            NotificationManager.error('Failed to start upgrade of ' + failed);
                        } else {
                            NotificationManager.success('Succeed to start upgrade of selected tenants.');
                        }
                        if (selected.length - failed.length > 0) {
                            this.setState({
                                upgradeInfo: {
                                    upgradeInProgress: true,
                                    totalTenantsToUpgrade: selected.length - failed.length,
                                    tenantUpgradesCompleted: 0
                                }
                            });
                            if (this.timer === null) {
                                console.log("Start interval check");
                                this.timer = setInterval(this.getUpgradeStatus, 10000);
                            }
                        }
                        this.upgradeModal.close();
                    }
                });
        }
    }

    upgradeAllTenant = () => {
        request.post('/api/tenant-manager/upgrade').withCredentials()
            .set('Accept', 'application/json')
            .end((error, response) => {
                if (error) {
                    console.error(error);
                    NotificationManager.error('Failed to start upgrade of all tenants.');
                } else {
                    this.setState({
                        upgradeInfo: {
                            upgradeInProgress: true,
                            totalTenantsToUpgrade: this.state.dataList.length,
                            tenantUpgradesCompleted: 0
                        }
                    });
                    if (this.timer === null) {
                        console.log("Start interval check");
                        this.timer = setInterval(this.getUpgradeStatus, 10000);
                    }
                    NotificationManager.success('Succeed to start upgrade of all tenants.');
                }
                this.upgradeAllModal.close();
            });
    }

    upgradeGlobal = () => {
        request.post('/api/tenant-manager/00000000-0000-4000-8000-000000000000/upgrade').withCredentials()
            .set('Accept', 'application/json')
            .end((error, response) => {
                if (error) {
                    console.error(error);
                    NotificationManager.error('Failed to upgrade Apps & Msg-schema in Global tenant.');
                } else {
                    NotificationManager.success('Succeed to upgrade Apps & Msg-schema in Global tenant.');
                }
                this.upgradeGlobalModal.close();
            });
    }

    onRowSelect = (row, isSelected, e) => {
        let tmp = this.state.selected;
        if (isSelected) {
            tmp.push(row);
            this.setState({selected: tmp});
        } else {
            tmp = tmp.filter(t => t.tenantId !== row.tenantId);
            this.setState({ selected: tmp });
        }
    }

    onSelectAll = (isSelected, rows) => {
        if (!isSelected) {
            this.setState({ selected: [] });
        } else {
            this.setState({ selected: rows });
        }
    }

    closeDetail = () => {
        this.setState({tenantId: ''});
    }

    freshListAfterOperation = (tenant) => {
        let tmp = this.state.dataList;
        tmp = tmp.filter((t) => { return t.tenantId !== tenant.tenantId });
        tmp.push(tenant);
        this.setState({dataList: tmp});
    }

    createCustomToolBar = props => {
        const { tenantId, selected } = this.state;
        const isHideAdd = !permissionCheck([Permissions.TenantManager.ADD]);
        const isHideDelete = !permissionCheck([Permissions.TenantManager.DELETE]);
        const isHideUpgrade = !permissionCheck([Permissions.TenantManager.UPDATE]);

        return (
            <div>
                <div className='buttonFiled' style={{ display: tenantId === '' ? 'block' : 'none' }}>
                    <ToolBar onFresh={this.getTenantList}
                             onAdd={this.toggleAddModal} isHideAdd={isHideAdd}
                             onDelete={this.openDeleteModal} disableDelete={selected.length <= 0} isHideDelete={isHideDelete}
                             extension={
                             !isHideUpgrade && <div style={{display: 'inline-block'}}>
                                <Button onClick={this.openUpgradeModal} title="Upgrade" disabled={selected.length <= 0}>
                                    <SvgIcon name="upgrade" style={{ color: "#00ADEE" }} />Upgrade
                                </Button>
                                <Button onClick={this.openUpgradeAllModal} title="Upgrade All">
                                    <SvgIcon name="upgrade" style={{ color: "#00ADEE" }} />Upgrade All
                                </Button>
                                <Button onClick={this.openUpgradeGlobalModal} title="Upgrade Global">
                                    <SvgIcon name="upgrade" style={{ color: "#00ADEE" }} />Upgrade Global
                                </Button>
                             </div>
                             }/>
                </div>
                <div className='searchFiled' style={{width: tenantId === '' ? '': '100%'}}>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    trClassFormat = (row, rowIndex) => {
        if (row.tenantId === this.state.tenantId) {
            return "table_selected_row";
        }
    };

    render = () => {
        const { dataList, containerHeight, loading, tenantId, selected, showAdd, upgradeInfo } = this.state;
        const options = {
            defaultSortName: 'companyName',
            defaultSortOrder: 'asc',
            noDataText: loading ? <Loading /> : 'No tenant found.',
            toolBar: this.createCustomToolBar,
            searchDelayTime: 500
        };
        const selectRowProp = {
            mode: 'checkbox',
            bgColor: '#f1f1f1',
            onSelect: this.onRowSelect,
            onSelectAll: this.onSelectAll
        };
        const isHideRowSelect = !permissionCheck([Permissions.TenantManager.DELETE, Permissions.TenantManager.UPDATE]);
        let tableOptions = {
            data: dataList, search: true, options: options,
            maxHeight: containerHeight,
            bodyStyle: {overflowX: 'hidden'},
            multiColumnSearch: true
        };
        if (!isHideRowSelect) {
            tableOptions["selectRow"] = selectRowProp;
        }

        return (
            <div className="page-container">
                <div id="container" className={`${tenantId === '' ? 'col-md-12': 'col-md-5'} list`}>
                    <h2 className="page-title">Tenant&nbsp;<small>({dataList.length})</small></h2>
                    {upgradeInfo.upgradeInProgress && (
                        <div style={{paddingBottom:10}}>
                            <Alert type="info" showIcon
                                   message={'Upgrade in progress, '
                                   + upgradeInfo.tenantUpgradesCompleted + ' out of '
                                   + upgradeInfo.totalTenantsToUpgrade + ' tenants upgraded.'}/>
                        </div>
                    )}
                    <div>
                        <BootstrapTable ref="table" {...tableOptions}
                                        trClassName={this.trClassFormat} striped hover condensed>
                            <TableHeaderColumn dataField='companyName' dataSort={ true }
                                               dataFormat={this.nameCellFormat}>Company Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='tenantDomain' hidden={tenantId !== ''}
                                               width="20%" columnTitle={ true }>Domain</TableHeaderColumn>
                            <TableHeaderColumn dataField='tenantId' isKey width="25%" columnTitle={ true }
                                               hidden={tenantId !== ''}>ID</TableHeaderColumn>
                            <TableHeaderColumn dataField='versionData' hidden={tenantId !== ''}
                                               dataFormat={this.versionFormat} width="15%"
                                               filterFormatted={true}
                                               columnTitle={ true }>Data Version</TableHeaderColumn>
                            <TableHeaderColumn dataField='lastUpgradeTime' hidden={tenantId !== ''}
                                               dataFormat={this.timeFormat} width="15%"
                                               filterFormatted={true}
                                               columnTitle={ true }>Last Upgraded Time</TableHeaderColumn>
                            <TableHeaderColumn dataField='versionForSearch' hidden={ true }/>
                        </BootstrapTable>
                    </div>
                    <TenantAddModal langOptions={this.langOptions} showModal={showAdd}
                                    onSuccess={this.getTenantList} onClose={this.toggleAddModal}/>
                    <ConfirmDialog ref={modal => {this.deleteModal = modal}}
                                   title="Delete Tenants" confirmBtnType="danger"
                                   promptText={'Are you sure you want to delete the selected ' + selected.length + ' tenant(s)?'}
                                   cancelBtn="Cancel" confirmBtn="Delete"
                                   operate={this.deleteTenant}/>
                    <ConfirmDialog ref={modal => {this.upgradeModal = modal}}
                                   title="Upgrade Tenants"
                                   promptText={'Are you sure you want to upgrade the selected ' + selected.length + ' tenant(s) to the latest version?'}
                                   cancelBtn="Cancel" confirmBtn="Upgrade"
                                   operate={this.upgradeTenant}/>
                    <ConfirmDialog ref={modal => {this.upgradeAllModal = modal}}
                                   title="Upgrade All Tenants"
                                   promptText={'Are you sure you want to upgrade all tenants to the latest version?'}
                                   cancelBtn="Cancel" confirmBtn="Upgrade"
                                   operate={this.upgradeAllTenant}/>
                    <ConfirmDialog ref={modal => {this.upgradeGlobalModal = modal}}
                                   title="Upgrade Global"
                                   promptText={'Are you sure you want to upgrade Apps & Msg-schema in Global tenant?'}
                                   cancelBtn="Cancel" confirmBtn="Upgrade"
                                   operate={this.upgradeGlobal}/>
                </div>
                <div id="detailContainer" className={`${tenantId === '' ? 'col-md-0': 'col-md-7'} detailInfo`}>
                    {tenantId === '' ? ('') : (
                        <TenantDetailView tenantId={tenantId} close={this.closeDetail}
                                          langOptions={this.langOptions} freshList={this.freshListAfterOperation}/>
                    )}
                </div>
            </div>
        );
    }
}

export default TenantView;


// WEBPACK FOOTER //
// ./src/modules/tenants/TenantView.js